module.exports = __webpack_public_path__ + "static/media/cq_modifica_dati.4c92313c.svg";